export const FILTER_CONFIG = [
  {
    id: 'paycard',
    label: 'Оплата карткою',
    icon: '/icons/collection-points/card.svg',
    optKey: 'paycard'
  },
  {
    id: 'online',
    label: 'Онлайн запис',
    icon: '/icons/collection-points/online.svg',
    optKey: 'online'
  },
  {
    id: 'quickresult',
    label: 'Швидкий результат',
    icon: '/icons/collection-points/quickResult.svg',
    optKey: 'quickresult'
  },
  {
    id: 'ramp',
    label: 'Наявність пандусу',
    icon: '/icons/collection-points/ramp.svg',
    optKey: 'ramp'
  },
  {
    id: 'wodaysoff',
    label: 'Без вихідних',
    icon: '/icons/collection-points/wodaySoff.svg',
    optKey: 'wodaysoff'
  },
  {
    id: 'urogenital',
    label: 'Урогенітальний відбір',
    icon: '/icons/collection-points/urogenital.svg',
    optKey: 'urogenital'
  },
  {
    id: 'child1year',
    label: 'Відбір у дітей до 1 року',
    icon: '/icons/collection-points/child1year.svg',
    optKey: 'child1year'
  },
];
